var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame427320198(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 568,
    viewBox: "0 0 390 568",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 646,
    transform: "translate(-30)",
    fill: "#2D2D2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.439,
    cy: 35.7399,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.262,
    cy: 96.406,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9496,
    cy: 199.424,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.602,
    cy: 249.788,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.609,
    cy: 48.3309,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6158,
    cy: 161.651,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.267,
    cy: 212.015,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.317,
    cy: 114.72,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.053,
    cy: 376.844,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.7401,
    cy: 71.7845,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.053,
    cy: 266.958,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.904,
    cy: 96.6807,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.841,
    cy: 276.39,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.387,
    cy: 161.925,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.038,
    cy: 212.29,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.009,
    cy: 142.466,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.051,
    cy: 222.592,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.2639,
    cy: 107.852,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.915,
    cy: 158.217,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.728,
    cy: 59.7774,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.0122,
    cy: 356.24,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.87,
    cy: 346.253,
    r: 0.595215,
    transform: "rotate(-105 259.87 346.253)",
    fill: "#D9D9D9"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.664,
    cy: 406.604,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.968,
    cy: 379.133,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.689,
    cy: 279.517,
    r: 0.595215,
    transform: "rotate(-105 265.689 279.517)",
    fill: "#D9D9D9"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.21,
    cy: 207.78,
    r: 0.595215,
    transform: "rotate(150 207.21 207.78)",
    fill: "#D9D9D9"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.905,
    cy: 290.995,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.923,
    cy: 341.027,
    r: 0.595215,
    transform: "rotate(-105 190.923 341.027)",
    fill: "#D9D9D9"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.1836,
    cy: 312.858,
    r: 0.595215,
    transform: "rotate(45 45.1836 312.858)",
    fill: "#D9D9D9"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.243,
    cy: 219.432,
    r: 0.595215,
    transform: "rotate(150 141.243 219.432)",
    fill: "#D9D9D9"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5122,
    cy: 373.562,
    r: 0.595215,
    transform: "rotate(45 73.5122 373.562)",
    fill: "#D9D9D9"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.619,
    cy: 429.497,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.006,
    cy: 275.73,
    r: 0.595215,
    transform: "rotate(150 220.006 275.73)",
    fill: "#D9D9D9"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.506,
    cy: 282.911,
    r: 0.595215,
    transform: "rotate(45 107.506 282.911)",
    fill: "#D9D9D9"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.556,
    cy: 341.36,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.585,
    cy: 225.201,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.627,
    cy: 305.326,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7664,
    cy: 116.094,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.418,
    cy: 166.458,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5955,
    cy: 47.388,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.198,
    cy: 73.5131,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.701,
    cy: 58.6327,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.744,
    cy: 138.758,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.19,
    cy: 219.249,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.232,
    cy: 299.374,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3711,
    cy: 110.142,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.023,
    cy: 160.506,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.173,
    cy: 106.479,
    r: 0.366286,
    fill: "#D9D9D9"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.824,
    cy: 156.843,
    r: 0.366286,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame427320198);
export default __webpack_public_path__ + "static/media/Frame 427320198.f50796c157f11b27bac3f1b8031ac1cb.svg";
export { ForwardRef as ReactComponent };